import React from "react";
import { homeImages } from "../constants/homeImages";
import "./VisionApproach.css";
import "./homeGraphic.css";

const VisionApproach = () => {
  const items = [
    {
      title: "Our Vision",
      text: "To be a trusted and creative event management brand that delivers memorable experiences through innovation, precision, and flawless execution. We aim to set new benchmarks in the event industry by consistently exceeding expectations.",
    },
    {
      title: "Our Approach",
      text: "We believe every successful event begins with understanding. Our process starts with detailed research, thoughtful planning, and clear coordination. From concept to execution, we focus on every detail to ensure smooth operations and a seamless event experience.",
    },
    {
      title: "Our Promise",
      text: "We promise professionalism, transparency, and excellence in every project. Our commitment is to deliver high-quality events on time, within scope, and with complete client satisfaction—turning your vision into reality.",
    },
    {
      title: "Our Strengths",
      text: "Our strength lies in our experienced team, smart planning, and flawless execution. We combine creativity with practical solutions to deliver seamless events and complete client satisfaction.",
    },
  ];

  return (
    <section id="vision-approach" className="vision-approach">
      <div className="vision-approach-container">
        <div className="section-header">
          <h2 className="section-title">
            Our Vision, Our Approach, Our Promise, Our Strengths
          </h2>
          <div className="title-underline"></div>
        </div>
        <div className="vision-approach-grid">
          {items.map((item, index) => (
            <div key={index} className="vision-card">
              <div className="home-graphic-wrap home-graphic-wrap--vision">
                <img
                  src={homeImages.visionApproach[item.title]}
                  alt={item.title}
                  className="home-graphic-img"
                  decoding="async"
                  loading={index > 0 ? "lazy" : "eager"}
                />
              </div>
              <h3 className="vision-card-title">{item.title}</h3>
              <p className="vision-card-text">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionApproach;
